import React from "react";

class AutocompleteInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: false,
      inputValue: "",
    };
  }

  componentDidUpdate(prevProps) {
    // Si la sélection change de l'extérieur, mettre à jour la valeur affichée
    if (prevProps.selectedId !== this.props.selectedId && this.props.selectedId) {
      const { options, selectedId } = this.props;
      const selectedOption = options?.find((o) => o._id === selectedId);
      if (selectedOption) {
        this.setState({ inputValue: selectedOption.name });
      }
    }

    // Si la sélection est effacée de l'extérieur
    if (prevProps.selectedId && !this.props.selectedId && !this.state.focused) {
      this.setState({ inputValue: "" });
    }
  }

  handleFocus = () => {
    const { options, selectedId } = this.props;
    const selectedOption = options?.find((o) => o._id === selectedId);

    this.setState((prevState) => ({
      focused: true,
      inputValue: selectedOption ? selectedOption.name : prevState.inputValue,
    }));
  };

  handleBlur = () => {
    setTimeout(() => {
      const { inputValue } = this.state;
      const { options, onChange, selectedId } = this.props;

      // Si pas déjà sélectionné et qu'on a une valeur saisie
      if (!selectedId && inputValue && options) {
        const matchingOption = options.find(
          (o) => o.name.toUpperCase() === inputValue.toUpperCase()
        );
        if (matchingOption) {
          this.setState({ inputValue: matchingOption.name });
          onChange(matchingOption._id);
        }
      }

      this.setState({ focused: false });
    }, 200);
  };

  handleChange = (e) => {
    const value = e.target.value;
    this.setState({ inputValue: value });
    this.props.onChange(null);
    // Callback optionnel pour notifier le parent du changement de valeur
    if (this.props.onInputChange) {
      this.props.onInputChange(value);
    }
  };

  handleSelect = (option) => {
    this.setState({ inputValue: option.name });
    this.props.onChange(option._id);
  };

  handleClear = () => {
    this.setState({ inputValue: "" });
    this.props.onChange(null);
  };

  handleCreate = () => {
    const { inputValue } = this.state;
    const { onCreateOption, onChange } = this.props;

    if (onCreateOption && inputValue) {
      onCreateOption({ name: inputValue }, (newOption) => {
        this.setState({ inputValue: newOption.name });
        onChange(newOption._id);
      });
    }
  };

  getDisplayValue = () => {
    const { options, selectedId } = this.props;
    const { inputValue, focused } = this.state;

    if (focused) return inputValue;

    if (selectedId && options) {
      const selectedOption = options.find((o) => o._id === selectedId);
      return selectedOption ? selectedOption.name : "";
    }

    return inputValue;
  };

  getFilteredOptions = () => {
    const { options } = this.props;
    const { inputValue } = this.state;

    if (!options) return [];
    if (!inputValue) return options;

    return options.filter((o) =>
      o.name.toUpperCase().includes(inputValue.toUpperCase())
    );
  };

  // Méthode publique pour récupérer la valeur saisie (utilisée pour l'auto-création)
  getInputValue = () => {
    return this.state.inputValue;
  };

  // Méthode publique pour déclencher la création
  triggerCreate = (callback) => {
    const { inputValue } = this.state;
    const { onCreateOption, onChange, options } = this.props;

    if (!inputValue || !onCreateOption) {
      callback && callback(null);
      return;
    }

    // Vérifier si ça existe déjà
    const existingOption = options?.find(
      (o) => o.name.toUpperCase() === inputValue.toUpperCase()
    );

    if (existingOption) {
      this.setState({ inputValue: existingOption.name });
      onChange(existingOption._id);
      callback && callback(existingOption);
      return;
    }

    // Créer le nouvel élément
    onCreateOption({ name: inputValue }, (newOption) => {
      this.setState({ inputValue: newOption.name });
      onChange(newOption._id);
      callback && callback(newOption);
    });
  };

  render() {
    const {
      placeholder,
      disabled,
      selectedId,
      showCreateOption = true,
    } = this.props;
    const { focused, inputValue } = this.state;

    const filteredOptions = this.getFilteredOptions();
    const displayValue = this.getDisplayValue();
    const hasExactMatch = filteredOptions.some(
      (o) => o.name.toUpperCase() === inputValue.toUpperCase()
    );
    const showSuggestions = focused && (filteredOptions.length > 0 || inputValue);

    return (
      <div className="rental-ref-interne-input-wrapper">
        <input
          type="text"
          value={displayValue}
          onChange={this.handleChange}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          disabled={disabled}
          placeholder={placeholder}
          className="rental-ref-interne-input"
        />
        {selectedId && (
          <button
            type="button"
            className="rental-ref-interne-clear-btn"
            onClick={this.handleClear}
            disabled={disabled}
          >
            <i className="fas fa-times"></i>
          </button>
        )}
        <div className="rental-ref-interne-search-icon">
          <i className="fas fa-search"></i>
        </div>
        {showSuggestions && (
          <div className="rental-ref-interne-suggestions">
            {filteredOptions.map((option) => (
              <div
                key={option._id}
                className="rental-ref-interne-suggestion-item"
                onMouseDown={() => this.handleSelect(option)}
              >
                <span className="suggestion-ref">{option.name}</span>
              </div>
            ))}
            {showCreateOption && inputValue && !hasExactMatch && (
              <div
                className="rental-ref-interne-suggestion-item rental-create-option"
                onMouseDown={this.handleCreate}
              >
                <span className="suggestion-ref">
                  <i className="fas fa-plus"></i> Créer "{inputValue}"
                </span>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default AutocompleteInput;
